export default __webpack_public_path__ + "static/media/mint-your-toys.d8e0243c.svg";